import * as e from "react";
import a from "../lib/IconBase.es.js";
import n from "../defs/ChatCenteredText.es.js";
const t = e.forwardRef((o, r) => /* @__PURE__ */ e.createElement(a, { ref: r, ...o, weights: n }));
t.displayName = "ChatCenteredTextIcon";
const s = t;
export {
  s as ChatCenteredText,
  t as ChatCenteredTextIcon
};
